import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '@iarc-programing/emanufac-components/src/components/Button';
import { Loading } from '@iarc-programing/emanufac-components/src/components/Loading';
import { Error } from '@iarc-programing/emanufac-components/src/components/Error';
import { ViewTitle } from '@iarc-programing/emanufac-components/src/components/ViewTitle';

export default function DetailProductType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const productType = useSelector((state) => state.productType);

  useEffect(() => {
    dispatch(actions.productTypeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (productType.isLoading || productType.rows) {
    return <Loading />;
  }
  if (!productType.isLoading && productType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4 ">
            <div className="flex flex-wrap divide-y">
              <div className="w-full py-4 text-lg font-semibold font-display ">
                {'รายละเอียด'}
              </div>
              <div className="w-1/2 py-4 px-2 font-semibold font-display ">
                {'ชื่อ'}
              </div>
              <div className="w-1/2 py-4 ">{`${productType.name}`}</div>
              <div className="w-1/2 py-4 px-2 font-semibold font-display ">
                {'รายละเอียด'}
              </div>
              <div className="w-1/2 py-4 ">{`${productType.description}`}</div>
            </div>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

DetailProductType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DetailProductType.defaultProps = {
  title: '',
  subtitle: '',
};
